import React from 'react';
import { Box, useColorModeValue as mode } from '@chakra-ui/react';


export const Label = (props: any) => (
  <Box className="label" color={mode('black', 'gray.600')} {...props}>
    {props.children}
  </Box>
);
